__turbopack_context__.v({
  "image": "yKO0TW_image",
  "includingFeesText": "yKO0TW_includingFeesText",
  "sizeName": "yKO0TW_sizeName",
  "wrapper": "yKO0TW_wrapper",
});
